<template>
<!-- <Navbar/> -->
<!-- <SideBar/> -->

<div class="card main-content">
        <div class="progress-spinner" v-if="spinnerLoadingStatus">
            <ProgressSpinner></ProgressSpinner>
        </div>
        <div class="grid">  
          <div class="sm:col-12 md:col-3 lg:col-3 mr-3 ml-3">
                  <div class="surface-card shadow-2 p-3 border-round-xl  w-full mt-4 mr-3 ml-4 h-full">
                      <div class="mx-2 mt-2">
                        <label class="text-lg ">
                          Categories:
                        </label>
                      </div>
                      <div class="grid mt-2">
                          <div v-for="(category, index) in categories" :key="index" class="col-4">
                              <div class="ml-2">
                                <Button class="px-3 py-2 w-full" :label="category.label" outlined @click="filterItems(category)"/>
                              </div>
                          </div>
                      </div>

                      <div class="field mx-2 mt-5">
                        <div class="flex justify-content-between flex-wrap ">
                          <div class="flex align-items-center justify-content-center ">
                            <label class="text-lg" >Stock Filter</label>
                          </div>
                          <div class="flex align-items-center justify-content-center mr-2">
                            <!-- <Button icon="pi pi-filter" raised v-tooltip.top="'Filter stock'" @click="filterInOutStock"/> -->
                            <i v-if="stockFilterSelected && stockFilterSelected.id==1" class="pi pi-circle-fill" style="color: #34c015"></i>
                            <i v-if="stockFilterSelected && stockFilterSelected.id==2" class="pi pi-circle-fill" style="color: red"></i>
                          </div>
                        </div>
                          <Dropdown class="w-full mt-2" v-model="stockFilterSelected" showClear filter :options="stockFilter"  placeholder="Filter Stock" @change="filterItems(null)" >
                            <template #value="slotProps">
                                <div v-if="slotProps.value" class="flex align-items-center">
                                          <div>{{ slotProps.value.label }}</div>
                                      </div>
                                      <span v-else>
                                          {{ slotProps.placeholder }}
                                      </span>                               
                            </template>
                            <template #option="slotProps">
                                <Tag :value="slotProps.option.label" :severity="getStockFilterSeverity(slotProps.option.label)" />
                            </template>
                          </Dropdown>
                      </div>                    
                  </div>
          </div>

          <div class=" sm:col-12 md:col-8 lg:col-8 ml-3">
            <div class="flex justify-content-between flex-wrap mt-4 ml-5">
                <div class="flex align-items-center justify-content-center ">
                    <InputText v-model="searchQuery" placeholder="Search item" class="w-full mr-2" />
                    <Button icon="pi pi-search" class="px-3" raised @click="searchItem"/>
                    
                </div>

                <!-- <div class="flex align-items-center justify-content-center mr-5">
                  <Button label="Add Item" raised disabled/>
                </div> -->

                <div class="flex align-items-center justify-content-center ">
                  <div class="surface-card shadow-2  border-round-xl w-full py-2 pl-4 pr-4 h-5rem ">
                    <div class="field grid">
                        <label class="text-lg">Stock Value: </label>
                        <div class="col mt-3">
                            <div>
                              <label class="ml-2 text-lg font-semibold"> {{formatCurrency(totalStockValue)}}</label>
                              <label class="ml-2 text-500">(Ex-GST)</label> <br>
                            </div>
                            <div>
                              <label class="ml-2 text-lg font-semibold"> {{formatCurrency(totalStockGst)}}</label>
                              <label class="ml-2 text-500">(GST)</label>
                            </div>
                        </div>
                    </div>
                  </div>
                </div>
            </div>
            <div class="ml-5 mt-3 ">
              <div class="flex justify-content-between flex-wrap">
                <div class="flex align-items-center justify-content-center ">
                  <label class="text-lg text-600" >Items Stock:</label>
                  <label class="text-base text-500 ml-2" v-if="items.length > 0">Total of {{items.length}} items listed</label>
                </div>
                <div class="flex align-items-center justify-content-center ">
                  <label class="text-lg text-600">Catgeory:</label>
                  <label v-if="!selectedCategory" class="text-lg mr-5">All</label>
                  <label v-if="selectedCategory" class="text-lg mr-5">{{selectedCategory}}</label>
                  <Button icon="pi pi-download" size="small" class="mr-2" @click="exportExcel" v-tooltip.top="'Download Excel'" disabled/>
                  <Button label="Reset" icon="pi pi-refresh" size="small" severity="warning" @click="resetFilter" v-tooltip.top="'Remove filters'"/>
                </div>
              </div>
              
            </div>
            <div class="items-list-container">

              <div class="progress-spinner" v-if="loading">
                <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
              </div>
              <div v-for="(item, index) in items" :key="index" class="surface-card shadow-2  border-round-xl w-full mt-4 ml-5 h-5rem ">
                <div class="grid">
                    <div class="col-6">
                        <div class="field pt-2 ml-4">
                          <div>
                            <label class="text-xl">{{item.item}}</label>
                          </div>
                          <div>
                            <!-- <label class="text-sm text-700"> PO No.: </label> -->
                            <label class="text-sm text-500"> {{item.category.name}}</label>
                          </div>
                        </div>
                    </div>

                    <div class="col-2">
                      <div class="pt-3">
                          <label class="font-medium text-500">Qty: </label> 
                          <label >{{formatNumber(item.quantity)}}</label> | 
                          <!-- <label >{{formatCurrency(item.value)}}</label> <br> -->
                          <Tag v-if="item.quantity>0" value="In Stock" severity="success"/>
                          <Tag v-if="item.quantity<=0" value="Out of Stock" severity="danger"/>
                      </div>
                    </div>
                    
                    <div class="col-2">
                        <div class=" pt-3 ">
                          <!-- <Tag :value="item.status" severity="success"/>                           -->
                          <div>
                            Last Rate: {{formatCurrency(item.rate)}}
                          </div>
                          <div>
                            Value: {{formatCurrency(item.valueExGst)}}
                          </div>
                        </div>
                    </div>
                    <div class="col-2">
                      <div class="flex pt-2 pr-2">
                        <router-link :to="{
                            name: 'inventoryItemDetails',
                            params:{
                                id:item.id,
                            }
                        }" rel="noopener">
                          <Button icon="pi pi-eye" severity="help" text rounded v-tooltip.top="'View Details'"/>                            
                        </router-link>

                        <Button icon="pi pi-book" severity="info" @click="showLedgerDialog(item)" text rounded v-tooltip.top="'Ledger'"/>

                        <Button icon="pi pi-trash" severity="danger" text rounded v-tooltip.top="'Clear Stock'" @click="showClearStockDialog(item)"/>

                        <!-- <Button label="DN" severity="primary" text rounded v-tooltip.top="'Debit Note'" @click="showDebitNoteDialog(item)"/> -->
                      </div>
                    </div>                    
                </div>
              </div>
            </div>

          </div>
        </div>

</div>

 <Dialog :visible="itemLedgerVisibility" modal :closable="false" :header="itemLedgerHeader" :style="{ width: '110rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">

    <div class="formgroup-inline">
      <div class="field">
          <label >Closing Quantity: </label>
          <label >{{formatNumber(closingQty)}}</label>
      </div>
    </div>

    <div class="grid">
      <div class="col">
          <div class="surface-card shadow-2 p-3 border-round-xl">

            <div class="flex justify-content-between flex-wrap mb-2">
                <div class="flex align-items-center justify-content-center ">
                  <label class="text-lg font-medium">Invoice details</label>
                </div>
                <div class="flex align-items-center justify-content-center ">
                  <Calendar v-model="invoiceStartDate" :manualInput="false" placeholder="Start date" class="mr-1"/>
                  <Calendar v-model="invoiceEndDate" :manualInput="false" placeholder="End date" class="mr-1" />
                  <Button icon="pi pi-filter" size="small" raised v-tooltip.top="'Filter by date'" @click="fetchByDate"/>
                </div>
            </div>

            <DataTable :value="ledgerArr" size="small" :loading="loading2" showGridlines  tableStyle="min-width: 30vw"  dataKey="id" paginator :rows="100" :rowsPerPageOptions="[100, 500, 1000]" paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" currentPageReportTemplate="{first} to {last} of {totalRecords}" scrollable scrollHeight="50vh" stripedRows >

              <template #empty> 
                  <div class="flex justify-content-center">
                    <label class="font-medium">
                      Invoice not received
                    </label>
                  </div>
              </template>

              <Column header="Sl No." style="width:5%">
                  <template #body="slotProps">
                      {{slotProps.index + 1}}
                  </template>
              </Column>
              <Column field="date" header="Inv. Date"></Column>
              <Column field="name" header="Name"></Column>
              <Column field="oem" header="OEM"></Column>
              <Column field="invoiceNo" header="Invoice"></Column>
              <Column field="quantity" header="Quantity">                 
                <template #body="slotProps">
                  {{formatNumber(slotProps.data.quantity)}}
                </template>
              </Column>
              <Column field="availableQty" header="Available">                 
                <template #body="slotProps">
                  {{formatNumber(slotProps.data.availableQty)}}
                </template>
              </Column>
              <Column field="rate" header="Rate">
                <template #body="slotProps">
                  {{formatCurrency(slotProps.data.rate)}}
                </template>
              </Column>
              <Column field="valueInGst" header="Value">
                <template #body="slotProps">
                  {{formatCurrency(slotProps.data.valueInGst)}}
                </template>
              </Column>
              <Column header="Billing">
                <template #body="slotProps">
                  <div v-if="slotProps.data.bills.length>0">
                    <div v-for="(bill, index) in slotProps.data.bills" :key="index">
                      {{bill}}
                    </div>
                  </div>
                  <div v-if="slotProps.data.bills.length==0">
                    <Tag value="Pending" severity="danger"/>
                  </div>
                </template>
              </Column>
              <Column header="Challans">
                <template #body="slotProps">
                  <div v-if="slotProps.data.challans.length>0">
                  <!-- <Button label="Challans" size="small" @click="toggleOpDc($event, slotProps.data.challans)"/> -->
                  <Button label="Challans" size="small" @click="toggleDeliveryChallanDialog(slotProps.data)"/>
                  </div>
                  <div v-if="slotProps.data.challans.length==0">
                    NA
                  </div>
                </template>
              </Column>
              
              <template #footer> Total Inwards: {{formatNumber(ledgerClosingQty)}} </template>      

            </DataTable>
          </div>
      </div>

      <OverlayPanel ref="opDcs">
        <DataTable :value="challanArr" size="small" showGridlines  tableStyle="width: 40vw"  dataKey="id" >
        <template #empty> 
            <div class="flex justify-content-center">
              <label class="font-medium">
                No outward challan
                </label>                      
            </div>
        </template>

        <Column header="Sl No." style="width:5%">
            <template #body="slotProps">
                {{slotProps.index + 1}}
            </template>
        </Column>
        <Column field="dcDate" header="DC Date"></Column>
        <Column field="dept" header="Dept"></Column>
        <Column field="dc" header="DC No."></Column>
        <Column field="quantity" header="Quantity">
          <template #body="slotProps">
            {{formatNumber(slotProps.data.quantity)}} {{slotProps.data.uom}}
          </template>
        </Column>
        <Column field="batch" header="Batch"></Column>
        <Column field="partNo" header="Serial No."></Column>        
        <Column field="location" header="Location"></Column>        
        </DataTable>
      </OverlayPanel>




      <!-- <div class="col-5">
          <div class="surface-card shadow-2 p-3 border-round-xl">

            <div class="flex justify-content-between flex-wrap mb-2">
                <div class="flex align-items-center justify-content-center ">
                  <label class="text-lg font-medium">Challan details</label>
                </div>
                <div class="flex align-items-center justify-content-center ">
                </div>
            </div>

            <DataTable :value="challanArr" size="small" :loading="loading3" showGridlines  tableStyle="min-width: 25vw"  dataKey="id" paginator :rows="100" :rowsPerPageOptions="[100, 500, 1000]" paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" currentPageReportTemplate="{first} to {last} of {totalRecords}" scrollable scrollHeight="30vh" stripedRows >

              <template #empty> 
                  <div class="flex justify-content-center">
                    <label class="font-medium">
                      No outward challan
                      </label>                      
                  </div>
              </template>

              <Column header="Sl No." style="width:5%">
                  <template #body="slotProps">
                      {{slotProps.index + 1}}
                  </template>
              </Column>
              <Column field="dcDate" header="DC Date"></Column>
              <Column field="dept" header="Dept"></Column>
              <Column field="dc" header="DC No."></Column>
              <Column field="quantity" header="Quantity">
                <template #body="slotProps">
                  {{formatNumber(slotProps.data.quantity)}} {{slotProps.data.uom}}
                </template>
              </Column>
              
              <template #footer> Total Outwards: {{challanClosingQty}} </template>      

            </DataTable>
          </div>
      </div> -->
    </div>
    <template #footer>
        <div class="flex justify-content-end flex-wrap">
            <Button class="my-1 py-2 mr-2" label="Close" severity="danger" size="small" @click="itemLedgerVisibility=false"/>
        </div>
    </template> 
 </Dialog>

  <Dialog :visible="challanDialog" modal :closable="false" :header="itemChallanHeader" :style="{ width: '60rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
    <div>
      <DataTable :value="challanArr" size="small" showGridlines  tableStyle="width: 50vw"  dataKey="id" scrollable scrollHeight="400px" >
        <template #empty> 
            <div class="flex justify-content-center">
              <label class="font-medium">
                No outward challan
                </label>                      
            </div>
        </template>

        <Column header="Sl No." style="width:5%">
            <template #body="slotProps">
                {{slotProps.index + 1}}
            </template>
        </Column>
        <Column field="dcDate" header="DC Date"></Column>
        <Column field="dept" header="Dept"></Column>
        <Column field="dc" header="DC No."></Column>
        <Column field="quantity" header="Quantity">
          <template #body="slotProps">
            {{formatNumber(slotProps.data.quantity)}} {{slotProps.data.uom}}
          </template>
        </Column>
        <Column field="batch" header="Batch"></Column>
        <Column field="partNo" header="Serial No."></Column>        
        <Column field="location" header="Location"></Column>        
        </DataTable>
    </div>

    <template #footer>
        <div class="flex justify-content-end flex-wrap">
            <Button class="my-1 py-2 mr-2" label="Close" severity="danger" size="small" @click="challanDialog=false"/>
        </div>
    </template> 

  </Dialog>

  <Dialog :visible="clearStockDialog" modal :closable="false" :header="clearStockHeader" :style="{ width: '70vw' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">

    <DataTable :value="itemStockDetail" size="small" showGridlines stripedRows tableStyle="width: 68vw"  dataKey="id" scrollable scrollHeight="400px" v-model:editingRows="editStockRow" editMode="row" :pt="{
                table: { style: 'min-width: 25rem' },
                column: {
                    bodycell: ({ state }) => ({
                        style:  state['d_editing']&&'padding-top: 0.6rem; padding-bottom: 0.6rem;'
                    })
                }
                }" @row-edit-save="onRowEditClearStock($event)">

      <Column header="Sl No." style="width:3%">
          <template #body="slotProps">
              {{slotProps.index + 1}}
          </template>
      </Column>
      <!-- <Column field="hsn" header="HSN"></Column> -->
      <Column field="batch" header="Batch"></Column>
      <Column field="model" header="Model"></Column>
      <Column field="partNo" header="Pt/Sr No."></Column>
      <Column field="mfg" header="Mfg"></Column>
      <Column field="exp" header="Exp"></Column>
      <Column field="rate" header="Rate"></Column>
      <Column field="gstRate" header="GST (%)"></Column>
      <Column field="availableQty" header="In-Stock">
        <template #body="slotProps">
            {{ slotProps.data.availableQty }}
        </template>
        <template #editor="{ data, field }">
            <InputText v-model="data[field]" />
        </template>
      </Column>
      <Column field="remarks" header="Remarks">
        <template #editor="{ data, field }">
            <InputText v-model="data[field]" />
        </template>
      </Column>
      <Column :rowEditor="true" header="Action" style="width: 5%; min-width: 5rem" bodyStyle="text-align:center"></Column>
    </DataTable>

    <template #footer>
        <div class="flex justify-content-end flex-wrap">
            <Button class="my-1 py-2 mr-2" label="Close" severity="danger" size="small" @click="clearStockDialog=false"/>
        </div>
    </template> 
  </Dialog>

  <Dialog :visible="debitNoteDialog" modal :closable="false" :header="debitNoteHeader" :style="{ width: '60rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">

    <div v-if="debitNoteAllowed">
      <div class="flex justify-content-between flex-wrap mb-2">
        <div class="flex align-items-center justify-content-center ">
          <div class="formgrid grid">
              <div class="field col">
                  <label >Available Quantity:</label>
                  <InputNumber v-model="itemQty" class="w-full" disabled/>
              </div>
              <div class="field col">
                  <label >To be Debited:</label>
                  <InputNumber v-model="itemQtyDebit" class="w-full"/>
              </div>
              <div class="field col">
                  <label >DN Date:</label>
                  <Calendar v-model="dnDate" class="w-full"/>
              </div>
          </div>
        </div>
        <!-- <div class="flex align-items-center justify-content-center ">
          
        </div> -->
      </div>
    </div>

    <div v-if="!debitNoteAllowed">
      <div class="justify-content-center">
        <label class="text-lg">Debit note cannot be raised as quantity is Zero (0)</label>
      </div>
    </div>


    <template #footer>
        <div class="flex justify-content-end flex-wrap">
          <Button class="mr-2" label="Raise DN" severity="primary" raised size="small" v-tooltip.top="'Raise Debit Note'"/>
            <Button label="Close" severity="danger" size="small" @click="debitNoteDialog=false"/>
        </div>
    </template>
  </Dialog>
  
</template>

<script>
import { clearStock, getCategories, inventory, inventoryItemInvoiceDetails, itemLedger } from '@/services/apiService'
import ProgressSpinner from 'primevue/progressspinner'
// import Card from 'primevue/card'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
import { FilterMatchMode, FilterOperator } from 'primevue/api'
import Button from 'primevue/button'
import Dropdown from 'primevue/dropdown'
import Tag from 'primevue/tag'
import { ExportXcl } from '@/helpers/mixins/exportToExcel'
import Dialog from 'primevue/dialog'
import Calendar from 'primevue/calendar'
import { useFilter } from '../../composables/useFilter'
import OverlayPanel from 'primevue/overlaypanel'
import InputNumber from 'primevue/inputnumber'

export default {
  
  setup(){
    const { filterData, result } = useFilter()
    return {filterData, result}
  },
  
  mixins: [ExportXcl],

  components:{
    ProgressSpinner,
      // Card,
    DataTable,
    Column,
    InputText,
    Button,
    Dropdown,
    Tag,
      Dialog,
    Calendar,
      OverlayPanel,
      InputNumber,
    },

    data(){
      return{
        spinnerLoadingStatus:false,
        expandedRows:[],
        filters: {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                name: { value: null, matchMode: FilterMatchMode.IN },
            },
        categories:[],
        stockFilter:[ 
          {id:1, label:'In Stock'},
          {id:2, label:'Out of Stock'},
        ],
        stockFilterSelected:null,
        items:[],
        tempItems:[],
        constItemsList:[],
        searchQuery:null,
        loading:false,
        selectedCategory:null,
        itemLedgerVisibility:false,
        itemLedgerHeader:null,
        ledgerClosingQty:0,
        loading2:false,
        loading3:false,
        challanClosingQty:0,
        closingQty:0,
        invoiceStartDate:null,
        invoiceEndDate:null,
        ledgerItemId:null,
        challanDialog:false,
        itemChallanHeader:null,
        totalStockValue:0,
        totalStockGst:0,
        clearStockDialog:false,
        clearStockHeader:null,
        itemStockDetail:[],
        editStockRow:null,
        debitNoteDialog:false,
        debitNoteHeader:null,
        debitNoteAllowed:true,
        itemQty:0,
        itemQtyDebit:0,
        dnDate:null,
      }
    },

    methods:{
      getStoreStock(){
          this.loading = true
        inventory().then((res)=>{
          this.tempItems = res.data
          this.items = res.data          
          this.constItemsList = this.items
          this.totalStockValue = res.data.reduce(this.stockTotalValue, 0);
          this.totalStockGst = res.data.reduce(this.stockTotalGst, 0);
          this.loading = false          
        }).catch((error)=>{
          this.showErrorToast(error.response.data);
        })
      },
      stockTotalValue(total, e){
        return total + e.valueExGst;
      },
      stockTotalGst(total, e){
        return total + e.gstValue;
      },
      initFilters() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                name: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
                category: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
            };
        },
      getStockFilterSeverity(e){
        switch (e) {
            case 'In Stock':
                return 'success'
            case 'Out of Stock':
                return 'danger';
            default:
                break;
        }
      },
      searchItem(){
        this.loading = true
        var temp = [...this.constItemsList];
        this.items = []

        if(this.searchQuery==null){
          this.items = [...this.constItemsList];
          return
        }      
        this.filterData(temp, this.searchQuery)
        this.items = [...this.result]
        this.totalStockValue = this.items.reduce(this.stockTotalValue, 0);
        this.totalStockGst = this.items.reduce(this.stockTotalGst, 0);
        this.loading = false
      },
      exportExcel(){
        var fileHeader = [
           {key:'item', header:'Item', wdith:40 },
           {key:'quantity', header:'Quantity', wdith:10 },
           {key:'category.name', header:'Category', wdith:15 },
           {key:'stockLocation', header:'Stock at', wdith:20 },
        ]

        this.exportToExcel(fileHeader, this.items, 'stock_items_list')
      },
      resetFilter(){
        this.spinnerLoadingStatus = true
        this.searchQuery=null
        this.selectedCategory = null
        this.stockFilterSelected = null
        this.items = [...this.constItemsList];
        this.totalStockValue = this.items.reduce(this.stockTotalValue, 0);
        this.totalStockGst = this.items.reduce(this.stockTotalGst, 0);
        this.spinnerLoadingStatus = false
      },
      showLedgerDialog(item){
        this.ledgerArr = []
        this.challanArr = []
        this.closingQty = 0
        this.ledgerClosingQty = 0
        this.challanClosingQty = 0
        this.ledgerItemId = item.id
        this.invoiceStartDate = null
        this.invoiceEndDate = null
        this.itemLedgerVisibility = true
        this.itemLedgerHeader = 'Ledger: '+item.item       
        const query = '[]'
        this.fetchItemLedger(item.id, query)        
      },
      fetchItemLedger(id, query){
        this.loading2 = true
        this.loading3 = true
        this.ledgerArr = []
        this.challanArr = []

        itemLedger(id, query).then((res)=>{
          this.ledgerArr = res.data.ledger         
          
          this.challanArr = res.data.deliveryChallan
          this.ledgerClosingQty = this.getClosingQty(res.data.ledger)
          // this.challanClosingQty = this.getClosingQty(res.data.deliveryChallan)
          this.challanClosingQty = 0
          res.data.ledger.forEach(e => {
            this.challanClosingQty += this.getClosingQty(e.challans);
          });         
          
          this.closingQty = this.ledgerClosingQty - this.challanClosingQty
          this.loading2 = false
          this.loading3 = false
        }).catch((error)=>{
          this.showErrorToast(error.response.data)
          this.loading2 = false
          this.loading3 = false
        })
      },
      fetchByDate(){
        var strDate = this.invoiceStartDate.getFullYear()+'-'+(this.invoiceStartDate.getMonth()+1)+'-'+this.invoiceStartDate.getDate()
        var endDate = this.invoiceEndDate.getFullYear()+'-'+(this.invoiceEndDate.getMonth()+1)+'-'+this.invoiceEndDate.getDate()
        const query = 'invDate[gtEq]='+strDate+'&invDate[ltEq]='+endDate       
        this.fetchItemLedger(this.ledgerItemId, query)       
      },
      getClosingQty(arr){
        var tmp = 0 
        arr.forEach(e => {
          tmp += e.quantity;
        });
        return tmp
      },
      filterItems(category){
        this.spinnerLoadingStatus = true
        var temp = [...this.constItemsList];
        if(category){
          this.selectedCategory = category.label
          this.items = []  
          temp.forEach((e) => {
            if(e.category.id==category.key){
              this.items.push(e);
            }
          });
        }

        if(category==null && this.selectedCategory!=null){
          this.items = []  
          temp.forEach((e) => {
            if(e.category.name==this.selectedCategory){
              this.items.push(e);
            }
          });
        }

        if(this.stockFilterSelected!=null){
          if(this.stockFilterSelected.id==1){
            this.items = this.items.filter(this.filterZeroQtyItem);
          }
          if(this.stockFilterSelected.id==2){
            this.items = this.items.filter(this.filterOutOfStock);
          }
        }

        this.totalStockValue = this.items.reduce(this.stockTotalValue, 0);
        this.totalStockGst = this.items.reduce(this.stockTotalGst, 0);

        this.spinnerLoadingStatus = false
      },
      filterZeroQtyItem(e){        
        if(e.quantity>0 || e.quantity<0){
          return e
        }
      },
      filterOutOfStock(e){
        if(e.quantity==0 ){
          return e
        }
      },
      toggleOpDc(event, dc){
        this.challanArr = dc
        this.$refs.opDcs.toggle(event);
      },
      toggleDeliveryChallanDialog(item){
        this.challanArr = item.challans
        this.challanDialog = true
        this.itemChallanHeader = 'Delivery Challans: '+item.name  
      },
      showClearStockDialog(item){ 
               this.loading = true
        inventoryItemInvoiceDetails(item.id).then((res)=>{
          this.itemStockDetail = res.data;
          this.clearStockDialog = true;
          this.clearStockHeader = 'Clear Stock: '+item.item;
          this.loading = false
        }).catch((error)=>{
          this.showErrorToast(error.response.data)
          this.loading = false
        })
      },      
      onRowEditClearStock(event){
        if(!('remarks' in event.newData)){
          event.newData.remarks = null;
        }
        
        const data = {
          'oldData':event.data,
          'newData':event.newData,
        }

        clearStock(event.data.id, data).then((res)=>{
          this.clearStockDialog = false;
          this.showSuccessToast(res.data);
          this.getStoreStock();          
        }).catch((error)=>{
          this.clearStockDialog = false;
          this.showErrorToast(error.response.data)
        })

      },
      showDebitNoteDialog(item){
        this.debitNoteHeader = 'Debit Note: '+item.item;
  
        this.debitNoteAllowed=true;
        if(item.quantity==0){
          this.debitNoteAllowed=false;
        }

        this.itemQty = item.quantity;
        
        this.debitNoteDialog = true;
      },
      formatNumber(value) {
        return value.toLocaleString('en-IN');
      },
      formatCurrency(value) {
          if(value){
              return value.toLocaleString('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits:2, minimumFractionDigits:2});
          }
      },
      showErrorToast(error){
          this.$toast.add({ severity: 'error', summary: 'Error', detail:error.message, life: 3000 });
      },
      showSuccessToast(data){
          this.$toast.add({ severity: 'success', summary: 'Success', detail:data.message, life: 4000 });
      },
      exportData(){
          this.$refs.stockList.exportCSV();
      },
    },
    created(){
      this.initFilters()
    },
    mounted(){
      this.getStoreStock();
      getCategories().then((res)=>{        
        this.categories = res.data
      })
    }
}
</script>

<style scoped>

.progress-spinner {
    position: fixed;
    z-index: 999;
    height: 2em;
    width: 2em;
    overflow: show;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}

/* Transparent Overlay */
.progress-spinner:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.53);
}

.items-list-container{
  margin-top: 0.5rem;
  padding-right: 4rem;
  height: 75vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.custom-divider{
  color: #e3e3e3;
}

</style>